import { render, staticRenderFns } from "./MatchScoreModalTemplate.vue?vue&type=template&id=b55c7218&scoped=true&"
import script from "./MatchScoreModalTemplate.vue?vue&type=script&lang=js&"
export * from "./MatchScoreModalTemplate.vue?vue&type=script&lang=js&"
import style0 from "./MatchScoreModalTemplate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b55c7218",
  null
  
)

export default component.exports